module.exports = __webpack_public_path__ + "static/media/course-work-classes.a50bfa17.png";